import React from 'react';

const AdobeXdIcon = ({classes}) => (
  <svg className={classes} role="img" viewBox="0 0 512 512">
    <g id="_x33__x2C__XD_x2C__Adobe">
      <g>
        <path d="M323.036,288.219c0,57.204,36.282,62.385,48.04,62.385c11.76,0,16.924-2.192,16.924-2.192V229.224    c0,0-3.369-2.792-13.338-2.792C364.699,226.432,323.036,231.019,323.036,288.219z" />
        <path d="M0,0v512h512V0H0z M221.757,384l-48.368-100.103L125.577,384H81.034l66.07-130.529L83.311,126h45.077l47.601,98.241    L222.958,126h43.757l-64.844,125.938L269.97,384H221.757z M431,371.063c0,0-20.528,15.061-64.066,15.061    c-59.131,0-86.902-41.445-86.902-96.237c0-70.875,52.011-98.887,95.039-98.887c5.041,0,12.93,0,12.93,0v-65h43V371.063z" />
      </g>
    </g>
    <g id="Layer_1" />
  </svg>
);

export default AdobeXdIcon;
